import { render, staticRenderFns } from "./customer-index.vue?vue&type=template&id=3c7d7c60"
import script from "./customer-index.vue?vue&type=script&lang=js"
export * from "./customer-index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports